
function initBluAppSlider() {
  $('.blu_app_slider').each(function () {

    var $slider = $(this);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    $slider.slick({
      dots: true,
      arrows: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      adaptiveHeight: true
    });

    setTimeout(function () {
      $slider.slick('setPosition');
    }, 100);

  });
}

$(document).ready(function () {
  initBluAppSlider();
});

$(document).on('shopify:section:load', function (event) {
  if ($(event.target).find('.blu_app_slider').length) {
    initBluAppSlider();
  }
});



$(document).on('mouseenter', '.block_list .blocks', function() {
  // Add active class permanently when hovered
  $(this).addClass('active');
});




document.addEventListener('DOMContentLoaded', function () {

  const section1 = document.querySelector(
    '#shopify-section-template--23481134711040__app_works_n3rah4'
  );

  const section2 = document.querySelector(
    '#shopify-section-template--23481134711040__features_product_AmgkUx'
  );

  if (!section1 || !section2) return;

  // Create wrapper
  const wrapper = document.createElement('div');
  wrapper.className = 'merged-sections-wrapper';

  // Insert wrapper before the first section
  section1.parentNode.insertBefore(wrapper, section1);

  // Move both sections inside wrapper
  wrapper.appendChild(section1);
  wrapper.appendChild(section2);

});





document.querySelectorAll('.os__purchase_type_wrapper input[type="radio"]').forEach(function (input) {
  input.addEventListener('change', function () {
    document.querySelectorAll('.os__purchase_type_option').forEach(function (box) {
      box.classList.remove('is-checked');
    });
    input.closest('.os__purchase_type_option').classList.add('is-checked');
  });
});



(function () {
  function initStepper(qtyInput) {
    if (!qtyInput || qtyInput.dataset.stepperInit) return;
    qtyInput.dataset.stepperInit = 'true';

    var wrapper = document.createElement('div');
    wrapper.className = 'os__qty_stepper';
    qtyInput.parentNode.insertBefore(wrapper, qtyInput);
    wrapper.appendChild(qtyInput);

    var minusBtn = document.createElement('button');
    minusBtn.type = 'button';
    minusBtn.className = 'os__qty_btn os__qty_minus';
    minusBtn.textContent = '−';
    wrapper.insertBefore(minusBtn, qtyInput);

    var plusBtn = document.createElement('button');
    plusBtn.type = 'button';
    plusBtn.className = 'os__qty_btn os__qty_plus';
    plusBtn.textContent = '+';
    wrapper.appendChild(plusBtn);

    var min = parseInt(qtyInput.min, 10) || 1;
    var max = parseInt(qtyInput.max, 10) || Infinity;

    minusBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || min;
      if (val > min) qtyInput.value = val - 1;
    });

    plusBtn.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || min;
      if (val < max) qtyInput.value = val + 1;
    });
  }

  // initial run
  initStepper(document.getElementById('quantity'));

  // re-run whenever the form re-renders and swaps in a new #quantity input
  var formContainer = document.querySelector('.os__form') || document.body;
  var observer = new MutationObserver(function () {
    var freshInput = document.getElementById('quantity');
    if (freshInput && !freshInput.dataset.stepperInit) {
      initStepper(freshInput);
    }
  });

  observer.observe(formContainer, { childList: true, subtree: true });
})();